export default "__VITE_ASSET__DlZj2fpQ__"